import React, { useEffect } from 'react';
import axios from 'axios';
import config from '../config/index';
import UseStore from '../store/store';

export default function SendData({ steps }) {
  const { mpUser, mcq_1, mcq_2, mcq_3 } = UseStore();

  useEffect(() => {
    sendDataToChatBot();
  }, []);

  async function sendDataToChatBot() {
    const userDetails = mpUser.userDetails;
    const empId = mpUser.corpDetails.iwpEmployeeId;
    const accessToken = mpUser.accessToken;
    let dependentData = {};
    if (steps.selfOrFamily.value === "Self") {
      dependentData = {
        name: userDetails.displayName,
        gender: userDetails.gender,
        age: steps.selfAnswerAge.value,
        height: steps.selfAnswerHeight.value,
        weight: steps.selfAnswerWeight.value
      };
    } else if (steps.selfOrFamily.value === "Family Member") {
      dependentData = {
        name: steps.familyAnswerName.value,
        gender: steps.familyAnswerGender.value,
        age: steps.familyAnswerAge.value,
        height: steps.familyAnswerHeight.value,
        weight: steps.familyAnswerWeight.value
      };
    }

    const userData = {
      dependent: steps.selfOrFamily.value,
      userId: userDetails.userId,
      uuid: userDetails.uuid,
      email: userDetails.email,
      pmEntityId: userDetails.pmEntityID,
      phone: userDetails.phone || '',
      employeeId: empId,
      ...dependentData,
      physicalActivityV2: steps.physicalActivityV2.value,
      energyLevelsDuringDaV2: steps.energyLevelsDuringDaV2.value,
      appetiteLevel: steps.appetiteLevel.value,
      fruitsAndVeggieEatingHabbit: steps.fruitsAndVeggieEatingHabbit.value,
      hightFatFoodEatingHabbit: steps.hightFatFoodEatingHabbit.value,
      tobaccoConsumption: steps.tobaccoConsumption.value,
      alchoholConsumption: steps.alchoholConsumption.value,
      healthAndLifeStyle: steps.healthAndLifeStyle.value,
      healthyLifeBenefits: steps.healthyLifeBenefits.value,
      healthCheckUps: steps.healthCheckUps.value,
      diagnosedOrTreated: mcq_1,
      complaints: mcq_2,
      familyHealthCondtion: mcq_3,
      workDaysMissed: steps.workDaysMissed.value,
      BPRating: steps.BPRating.value,
      ECGReport: steps.ECGReport.value,
      TMTReport: steps.TMTReport.value,
      TotalCholesterol: steps.TotalCholesterol.value,
      BloodSugarLevel: steps.BloodSugarLevel.value,
      HbA1C: steps.HbA1C.value,
      stress: steps.stress.value,
      SleepPattern: steps.SleepPattern.value,
      accessToken:accessToken
    };

    try {
      await axios.post(config.healthData_url, userData);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <h2>Congratulations!</h2>
  );
}